import styled from "styled-components";

import { getColor, responsive } from "~/helpers/style";

import Button from "~/components/ui/Button";

import confetiCheckIcon from "~/assets/svg/confeti-check.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 68px 40px;
  width: 1000px;
  max-width: 100%;

  ${responsive("laptop", true)} {
    width: fit-content;
    padding: 28px 20px;
  }

  ${responsive("tablet", true)} {
    width: 100%;
    min-width: 100%;
    padding: 28px 20px;
  }
`;

export const CelebrationCheckIcon = styled.img.attrs({
  src: confetiCheckIcon,
  alt: "Celebration check icon",
})`
  width: 80px;
  margin-bottom: 16px;

  ${responsive("tablet", true)} {
    width: 64px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;

  span {
    font-size: 24px;

    ${responsive("mobileS", true)} {
      font-size: 20px;
    }
  }

  ${responsive("mobileS", true)} {
    justify-content: center;
    width: 90%;
  }
`;

export const Title = styled.p`
  font-family: Avenir;
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  line-height: 158%;
  color: #191919;
  margin-bottom: 0;
  text-align: center;

  ${responsive("mobileM", true)} {
    font-size: 16px;
    line-height: 140%;
  }
`;

export const TimelineContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 30px;
  gap: 12px;

  ${responsive("laptop", true)} {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;

export const TimelineBox = styled.div`
  display: flex;
  width: 273px;
  height: 191px;
  padding: 31px 13px;
  flex-direction: column;
  border-radius: 11px;
  border: 1px solid rgba(8, 31, 64, 0.08);
  align-items: center;

  ${responsive("laptop", true)} {
    width: 100%;
    height: auto;
  }

  ${responsive("tablet", true)} {
    padding: 16px 13px;
  }
`;

export const TimelineBoxIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f3451f;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 25.28px;
  background-color: #fff4eb;

  ${responsive("tablet", true)} {
    display: none;
  }
`;

export const TimelineText = styled.p`
  color: #191919;
  text-align: center;
  margin-top: 12px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;

  ${responsive("mobileM", true)} {
    font-size: 14px;
  }
`;

export const StyledButton = styled(Button)`
  border-radius: 6px;
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.0015em;
  padding: 10px 34px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background: #f3451f;

  color: ${getColor("white")};
  font-style: normal;
  font-weight: 800;
  line-height: 158%;
  margin: 0 auto;

  ${responsive("tablet", true)} {
    width: 100%;
  }
`;
